import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from '..';

type LayoutSliceState = {
  scrollX?: number;
  scrollY?: number;
  unauthSidebarMenuOpened?: boolean;
  authSidebarMenuOpened?: boolean;
  headerTitle?: string;
};

/**
 * Slice
 */
export const layoutSlice = createSlice({
  name: 'layoutSlice',
  initialState: {} as LayoutSliceState,
  reducers: {
    updateLayout: (state, action: PayloadAction<Partial<LayoutSliceState>>) => {
      return { ...state, ...action.payload };
    },
  },
});

/**
 * Actions
 */
export const { updateLayout } = layoutSlice.actions;

/**
 * Selectors
 */
export const selectLayoutSlice = (state: RootState) => state.layoutSlice;
